import { useMemo } from "react";

import { Flex } from "@aircall/tractor";

import { TalkRatioListProps } from "./TalkRatioList.decl";
import { TalkRatioListItem } from "./TalkRatioListItem";

function byTotalDesc([, aTotal]: number[], [, bTotal]: number[]): number {
  return bTotal > aTotal ? 1 : -1;
}

export function TalkRatioList({ talkRatio, speakers }: TalkRatioListProps) {
  const sorted = useMemo(
    () => [...talkRatio.entries()].sort(byTotalDesc),
    [talkRatio]
  );

  if (!speakers) {
    return null;
  }

  return (
    <Flex gap="xxxs" flexDirection="column" w="100%">
      {sorted.map(([channel, ratio], index) => (
        <TalkRatioListItem
          speakers={speakers}
          channel={channel}
          ratio={ratio}
          index={index}
          key={channel}
        />
      ))}
    </Flex>
  );
}
